var path = 'views/display/submitted_with_npa_info.html';
var html = "<div class=\"fd-m-field fd-m-field-text\"> <div class=fd-m-defaultField-container ng-include=\"'views/display/default_field.html'\"></div> <div>NPA Info Anzeige</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;